import axios from "axios";
import React, { useEffect, useState } from "react";
import { Header, Grid, Button } from "semantic-ui-react";
import { BaseUrl } from "../formcomponents/Constants";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AiFillEdit } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { userData } from "../store/userData";
const ListCompany = () => {
  //listCompany
  const userDetail = userData();
  const navigate = useNavigate();
  useEffect(() => {
    getCompanyList();
  }, []);
  const [rowData, setrowData] = useState(null);
  const getCompanyList = async () => {
    await axios
      .get(BaseUrl + "listCompany")
      .then((res) => {
        console.log("res", res.data);
        setRecordForTable(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const setRecordForTable = (record) => {
    const tempRecord = record.map(
      ({ userId, companyId, companyName, activities, typeOfCompany }) => ({
        userId: userId,
        companyId: companyId,
        companyName: companyName,
        activities: activities,

        typeOfCompany: typeOfCompany,
      })
    );
    setrowData(tempRecord);
  };

  const columnDefs = [
    { headerName: "Company Name ", field: "companyName" },

    { headerName: "Activities", field: "activities" },
    { headerName: "Type Of Company", field: "typeOfCompany" },

    {
      headerName: "Edit",
      filter: false,
      field: "companyId",
      cellRendererFramework: (params) => (
        <div>
          <Button color="primary" onClick={() => updateRecord(params)}>
            <AiFillEdit />
          </Button>
        </div>
      ),
    },
  ];

  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    filter: true,
    floatingFilter: true,
  };

  const updateRecord = (params) => {
    // console.log("Params", params.data);
    navigate(`/create-company/${params.data.companyId}/` + params.data.userId);
  };
  return (
    <div>
      <Grid.Row>
        <Header dividing size="huge" as="h1">
          Company List
        </Header>
      </Grid.Row>
      <br />
      <Grid.Row>
        <Button
          color="primary"
          onClick={() => navigate("/create-company/null/null")}
        >
          Create New
        </Button>
      </Grid.Row>
      <br />
      <Grid.Row>
        <div className="ag-theme-alpine" style={{ height: 600 }}>
          <AgGridReact
            rowData={rowData}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            pagination={true}
          ></AgGridReact>
        </div>
      </Grid.Row>
    </div>
  );
};

export default ListCompany;
